/* ============================================================================
   DY MOTION — versión segura (sin MutationObservers)
   ========================================================================= */

(() => {
  'use strict';

  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const body = document.body;

  function stickyHeader() {
    let ticking = false;

    function update() {
      const y = window.scrollY;
      const drawerOpen = document.querySelector('#Details-menu-drawer-container[open], #Details-menu-drawer-container.menu-open');
      body.classList.toggle('dy-header-scrolled', y > 8);
      if (drawerOpen) {
        body.classList.remove('dy-header-hidden');
      }
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  function observeReveals() {
    const els = document.querySelectorAll('[data-dy-reveal]');
    if (!els.length) return;
    if (REDUCED) {
      els.forEach((el) => el.classList.add('dy-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('dy-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
    );
    els.forEach((el) => io.observe(el));
    setTimeout(() => els.forEach((el) => el.classList.add('dy-in')), 2500);
  }

  function megaMenu() {
    document.querySelectorAll('.dy-menu-scrim').forEach((el) => el.remove());
    const header = document.querySelector('#header-component');
    if (!header) return;

    function isMegaOpen() {
      const menu = header.querySelector('header-menu');
      if (menu?.getAttribute('aria-expanded') === 'true') return true;
      if (header.querySelector('.menu-list__submenu[data-active]')) return true;
      if (header.querySelector('.menu-list__link[aria-haspopup][aria-expanded="true"]')) return true;
      const submenuHeight = header.style.getPropertyValue('--submenu-height').trim();
      if (submenuHeight && submenuHeight !== '0px' && submenuHeight !== '0') return true;
      return false;
    }

    function syncMenuOpen() {
      const open = isMegaOpen();
      body.classList.toggle('dy-menu-open', open);
      if (open) {
        header.setAttribute('data-dy-mega-open', '');
      } else {
        header.removeAttribute('data-dy-mega-open');
      }
    }

    function syncSoon() {
      syncMenuOpen();
      requestAnimationFrame(() => {
        syncMenuOpen();
        window.setTimeout(syncMenuOpen, 40);
        window.setTimeout(syncMenuOpen, 120);
      });
    }

    function closeChrome() {
      header.querySelectorAll('.menu-list__link[aria-expanded="true"]').forEach((el) => {
        el.setAttribute('aria-expanded', 'false');
      });
      header.querySelectorAll('.menu-list__submenu[data-active]').forEach((el) => {
        delete el.dataset.active;
      });
      header.style.setProperty('--submenu-height', '0px');
      const hm = header.querySelector('header-menu');
      if (hm) {
        hm.style.setProperty('--submenu-opacity', '0');
        hm.dataset.overflowExpanded = 'false';
        hm.setAttribute('aria-expanded', 'false');
      }
      body.classList.remove('dy-menu-open');
      header.removeAttribute('data-dy-mega-open');
    }

    header.addEventListener('pointerover', syncSoon);
    header.addEventListener('pointerout', syncSoon);
    header.addEventListener('focusin', syncSoon);
    header.addEventListener('focusout', syncSoon);

    header.addEventListener('pointerleave', () => {
      requestAnimationFrame(() => {
        if (!header.matches(':hover')) closeChrome();
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeChrome();
    });

    syncMenuOpen();
  }

  function init() {
    stickyHeader();
    observeReveals();
    megaMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
